// extracted by mini-css-extract-plugin
export default {"root":"SensorInfoContainer_root__xeygz","empty":"SensorInfoContainer_empty__o8LN2"};